import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { css } from '@emotion/react';
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7af6097e56f7fb03635b6f8aaf121b02>>
 * @codegenId dimensions
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenParams ["dimensions"]
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::0cd422575c3f2a3784eeef767abe71f4>>
 */
export var dimensionMap = {
  '100%': '100%',
  'size.100': '1rem',
  'size.200': '1.5rem',
  'size.300': '2rem',
  'size.400': '2.5rem',
  'size.500': '3rem',
  'size.600': '6rem',
  'size.1000': '12rem'
};
/**
 * @codegenEnd
 */
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::429dca3ce1fa6d723cb98e2468802267>>
 * @codegenId spacing
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::68f6bde7e6b186964ee53458284bbb90>>
 */
export var spaceMap = {
  'space.0': "var(--ds-space-0, 0px)",
  'space.025': "var(--ds-space-025, 2px)",
  'space.050': "var(--ds-space-050, 4px)",
  'space.075': "var(--ds-space-075, 6px)",
  'space.100': "var(--ds-space-100, 8px)",
  'space.150': "var(--ds-space-150, 12px)",
  'space.200': "var(--ds-space-200, 16px)",
  'space.250': "var(--ds-space-250, 20px)",
  'space.300': "var(--ds-space-300, 24px)",
  'space.400': "var(--ds-space-400, 32px)",
  'space.500': "var(--ds-space-500, 40px)",
  'space.600': "var(--ds-space-600, 48px)",
  'space.800': "var(--ds-space-800, 64px)",
  'space.1000': "var(--ds-space-1000, 80px)"
};
/**
 * @codegenEnd
 */
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58f7acf912c1f55cbaa7a5be887f1b44>>
 * @codegenId colors
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenParams ["border", "background", "shadow", "text", "fill"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::d09e7cd13e24113267155813747b3bd4>>
 */
export var borderColorMap = {
  'color.border': "var(--ds-border, #091e4221)",
  'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
  'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
  'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
  'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
  'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
  'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
  'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
  'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
  'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
  'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
  'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
  'color.border.focused': "var(--ds-border-focused, #2684FF)",
  'color.border.input': "var(--ds-border-input, #FAFBFC)",
  'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
  'color.border.selected': "var(--ds-border-selected, #0052CC)",
  'color.border.brand': "var(--ds-border-brand, #0052CC)",
  'color.border.danger': "var(--ds-border-danger, #FF5630)",
  'color.border.warning': "var(--ds-border-warning, #FFC400)",
  'color.border.success': "var(--ds-border-success, #00875A)",
  'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
  'color.border.information': "var(--ds-border-information, #0065FF)",
  'color.border.bold': "var(--ds-border-bold, #344563)"
};
export var backgroundColorMap = {
  'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
  'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
  'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
  'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
  'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
  'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
  'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
  'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
  'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
  'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
  'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
  'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
  'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
  'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
  'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
  'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
  'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
  'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
  'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
  'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
  'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
  'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
  'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
  'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
  'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
  'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
  'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
  'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
  'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
  'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
  'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
  'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
  'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #E774BB)",
  'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #E774BB)",
  'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
  'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #E774BB)",
  'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
  'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
  'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #42526E)",
  'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #505F79)",
  'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
  'color.background.input': "var(--ds-background-input, #FAFBFC)",
  'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
  'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
  'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
  'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
  'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
  'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
  'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
  'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
  'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
  'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
  'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
  'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
  'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
  'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
  'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
  'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
  'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
  'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
  'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
  'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
  'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
  'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
  'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
  'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
  'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
  'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
  'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
  'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
  'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
  'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
  'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
  'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
  'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
  'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
  'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
  'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
  'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
  'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
  'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
  'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
  'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
  'color.background.success': "var(--ds-background-success, #E3FCEF)",
  'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
  'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
  'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
  'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
  'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
  'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
  'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
  'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
  'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
  'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
  'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
  'color.background.information': "var(--ds-background-information, #DEEBFF)",
  'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
  'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
  'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
  'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
  'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
  'color.blanket': "var(--ds-blanket, #091e4289)",
  'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
  'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
  'elevation.surface': "var(--ds-surface, #FFFFFF)",
  'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
  'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
  'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
  'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
  'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
  'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
  'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
  'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
  'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
export var shadowMap = {
  'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
  'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
  'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
  'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
  'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
export var textColorMap = {
  'color.text': "var(--ds-text, #172B4D)",
  'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
  'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
  'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
  'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
  'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
  'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
  'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
  'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
  'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
  'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
  'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
  'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
  'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
  'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
  'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
  'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
  'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
  'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
  'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
  'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
  'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
  'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
  'color.text.selected': "var(--ds-text-selected, #0052CC)",
  'color.text.brand': "var(--ds-text-brand, #0065FF)",
  'color.text.danger': "var(--ds-text-danger, #DE350B)",
  'color.text.warning': "var(--ds-text-warning, #974F0C)",
  'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
  'color.text.success': "var(--ds-text-success, #006644)",
  'color.text.discovery': "var(--ds-text-discovery, #403294)",
  'color.text.information': "var(--ds-text-information, #0052CC)",
  'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
  'color.text.subtle': "var(--ds-text-subtle, #42526E)"
};
export var fillMap = {
  'color.icon': "var(--ds-icon, #505F79)",
  'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
  'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
  'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
  'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
  'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
  'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
  'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
  'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
  'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
  'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
  'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
  'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
  'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
  'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
  'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
  'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
  'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
  'color.icon.success': "var(--ds-icon-success, #00875A)",
  'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
  'color.icon.information': "var(--ds-icon-information, #0747A6)",
  'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
/**
 * @codegenEnd
 */
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01a4b055c311d198921d4e000a2d7a54>>
 * @codegenId misc
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenParams ["layer"]
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::0cd422575c3f2a3784eeef767abe71f4>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::79d24a1e558f12d671c06a7609f90dc1>>
 */
export var layerMap = {
  card: 100,
  navigation: 200,
  dialog: 300,
  layer: 400,
  blanket: 500,
  modal: 510,
  flag: 600,
  spotlight: 700,
  tooltip: 800
};
/**
 * @codegenEnd
 */
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffa10f95df2d9bbc0f5d91f9d19b9a69>>
 * @codegenId border
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenParams ["width", "radius"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::25105916a589322f57c322068cb0074a>>
 */
export var borderWidthMap = {
  'border.width': "var(--ds-border-width, 1px)",
  'border.width.0': "var(--ds-border-width-0, 0px)",
  'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
  'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
export var borderRadiusMap = {
  'border.radius.050': "var(--ds-border-radius-050, 2px)",
  'border.radius': "var(--ds-border-radius, 3px)",
  'border.radius.100': "var(--ds-border-radius-100, 3px)",
  'border.radius.200': "var(--ds-border-radius-200, 8px)",
  'border.radius.300': "var(--ds-border-radius-300, 12px)",
  'border.radius.400': "var(--ds-border-radius-400, 16px)",
  'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};

/**
 * @codegenEnd
 */

// Generate maps for Box props. backgroundColor, padding, etc
var spacingProperties = [
// Used by Box
'padding', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd',
// Used by Inline and Stack
'gap', 'rowGap', 'columnGap'];
var getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
  return Object.keys(tokenMap).reduce(function (emotionSpacingMap, token) {
    emotionSpacingMap[token] = css(_defineProperty({}, cssProperty, tokenMap[token]));
    return emotionSpacingMap;
  }, {});
};
export var paddingStylesMap = spacingProperties.reduce(function (styleMap, spacingProperty) {
  styleMap[spacingProperty] = getSerializedStylesMap(spacingProperty, spaceMap);
  return styleMap;
}, {});
export var spaceStylesMap = spacingProperties.reduce(function (styleMap, spacingProperty) {
  styleMap[spacingProperty] = getSerializedStylesMap(spacingProperty, spaceMap);
  return styleMap;
}, {});
export var backgroundColorStylesMap = getSerializedStylesMap('backgroundColor', backgroundColorMap);